import { courierMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"
import { CourierEntity } from "../../Objects/Courier/CourierEntity"

export const useGetCourier = () => {
  const { t } = useTranslation("general")

  const { enableFlagLoad, disableFlagLoad } = useLoad()

  const { setError } = useError()

  const handleGetCourier = async (onSuccess: any) => {
    enableFlagLoad()

    try {
      const response = await GetRequest<CourierEntity[]>(API_ROUTES.DELIVERY.GET_ALL)

      if (response.success) {
        const temp = response.data?.map((e) => new CourierEntity(e)) ?? []

        courierMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableFlagLoad()
    }
  }

  return {
    handleGetCourier,
  }
}
